import translations from "@/config/translations";
import useAuthStore from "@/hooks/useAuthStore";
import useLangStore from "@/hooks/useLangStore";
import usePopupStore from "@/hooks/usePopupStore";
import ClientPopup from "@/UI/popups/ClientPopup";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.css";

const ROUTE_LABEL_KEYS: Record<string, keyof typeof translations.ar.nav> = {
    "/": "home",
    "/branches": "branches",
    "/products": "products",
    "/tiers": "tiers",
    "/challenges": "challenges",
    "/ad-banners": "adBanners",
    "/clients": "clients",
    "/settings": "settings",
    "/profile": "profile",
};

interface AppBarProps {
    onMenuClick: () => void;
}

export default function AppBar({ onMenuClick }: AppBarProps) {
    const { lang } = useLangStore();
    const { client } = useAuthStore();
    const { addComp, removeComp } = usePopupStore();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const profileRef = useRef<HTMLButtonElement>(null);
    const t = translations[lang ?? "ar"];

    const labelKey = Object.entries(ROUTE_LABEL_KEYS)
        .filter(([key]) => pathname === key || (key !== "/" && pathname.startsWith(key + "/")))
        .sort((a, b) => b[0].length - a[0].length)[0]?.[1];
    const pageTitle = labelKey ? t.nav[labelKey] : "";

    const openClientMenu = () => {
        const rect = profileRef.current?.getBoundingClientRect();
        if (!rect) return;
        const name = "client-menu";
        removeComp(name);
        addComp({
            name,
            Component: ClientPopup,
            details: { navigate },
            place: "anchor-below",
            anim: "scaleTop",
            cover: "invisible",
            coverClose: true,
            anchor: { top: rect.top, left: rect.left, right: rect.right, bottom: rect.bottom, width: rect.width, height: rect.height },
        });
    };

    return (
        <header className="appbar">
            <button className="appbar-menu-btn" aria-label="Menu" onClick={onMenuClick} type="button">
                <img src="/icons/menu-icon.svg" alt="" width={18} height={16} />
            </button>
            <p className="appbar-title">{pageTitle}</p>
            <div className="appbar-spacer" />
            <div className="appbar-actions">
                {/* <button className="appbar-icon-btn" aria-label={t.appBar.search}>
                    <img src="/icons/search-icon.svg" alt="" width={18} height={18} />
                </button>
                <button className="appbar-icon-btn" aria-label={t.appBar.notifications}>
                    <img src="/icons/notifications-icon.svg" alt="" width={18} height={18} />
                </button> */}
                {client && (
                    <button ref={profileRef} className="appbar-profile" onClick={openClientMenu} type="button">
                        <div className="appbar-profile-avatar">
                            {client?.picture ? (
                                <img src={client?.picture} />
                            ) : (
                                <img src="/icons/client-small-placeholder-icon.svg" alt={client.name} width={25} height={25} />
                            )}
                        </div>
                        <div className="appbar-profile-info">
                            <p className="appbar-profile-name">{client.name}</p>
                        </div>
                    </button>
                )}
            </div>
        </header>
    );
}
